/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */


import { createSlice } from '@reduxjs/toolkit';

export const categorySlice = createSlice({
  name: "category",
  initialState: {
    modalStatus: false,
    selectedCategory: null
  },
  reducers: {
    openAddCategoryModal: (state) => {

      state.modalStatus = "add";
    },
    openEditCategoryModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedCategory = action.payload;
    },
    openDeleteCategoryModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedCategory = action.payload;
    },
    closeCategoryModal: (state) => {
      state.modalStatus = false;
      state.selectedCategory = null;
    }
  }
});

export const {
  openAddCategoryModal,
  openEditCategoryModal,
  openDeleteCategoryModal,
  closeCategoryModal
} = categorySlice.actions;

export default categorySlice.reducer;